module.exports = __webpack_public_path__ + "static/forms-77bc4576ac7feb0703096080a076dbb0.png";